import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useStore } from '@/lib/store';
import { auth } from '@/lib/api';

export function Layout() {
  const { user, isAuthenticated, setUser } = useStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await auth.logout();
    setUser(null);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center space-x-2 group">
              <span className="font-bold text-2xl uppercase tracking-tight text-primary-500 group-hover:animate-pout">
                Zlandr<span className="text-accent-500 italic">.com</span>
              </span>
            </Link>

            <div className="hidden md:flex items-center space-x-2 text-sm text-gray-500">
              <span>an</span>
              <a
                href="https://affordablemagic.net"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-primary-600 hover:text-primary-700 transition-colors"
              >
                Affordable Magic
              </a>
              <span>product</span>
            </div>

            <nav className="flex items-center space-x-6">
              <Link
                to="/generate"
                className="text-gray-600 hover:text-primary-600 font-medium transition-colors"
              >
                Create
              </Link>

              {isAuthenticated ? (
                <>
                  <Link
                    to="/dashboard"
                    className="text-gray-600 hover:text-primary-600 font-medium transition-colors"
                  >
                    Dashboard
                  </Link>
                  <div className="flex items-center space-x-4">
                    <span className="text-sm text-gray-500">{user?.email}</span>
                    <button
                      onClick={handleLogout}
                      className="text-gray-600 hover:text-primary-600 font-medium transition-colors"
                    >
                      Logout
                    </button>
                  </div>
                </>
              ) : (
                <Link
                  to="/generate"
                  className="btn-primary text-sm"
                >
                  Get Started
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="bg-primary-500 text-white/80 py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} Zlandr.com. All rights reserved.
            </p>
            <p className="text-sm">
              An{' '}
              <a
                href="https://affordablemagic.net"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-accent-500 transition-colors font-semibold"
              >
                Affordable Magic
              </a>
              {' '}Product
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
